import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { containerApp } from '../../main';

export const controlsPortalClassName = 'js-primary-header-controls';

class PrimaryHeader extends Component {
  static propTypes = {
    children: PropTypes.node,
  }

  static defaultProps = {
    children: null,
  }

  static contextTypes = {
    toggleSidebar: PropTypes.func.isRequired,
  }

  openSidebar = () => {
    this.context.toggleSidebar(true);
  }

  render() {
    return (
      <header className="c-header-primary c-header-primary--inner-page">
        {/* eslint-disable jsx-a11y/no-static-element-interactions */}
        <div
          className="c-hamburger"
          onClick={this.openSidebar}
          display-if={!containerApp.isActive()}
        >
          <div className="c-header-primary__item"><span className="c-mobile-nav" /></div>
        </div>
        {this.props.children}
        <div className={cx('c-primary-header-controls', controlsPortalClassName)} />
      </header>
    );
  }
}

export default PrimaryHeader;
